import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import ApolloProvider from './lib/Apollo/Provider';
import IntlProvider from './lib/Intl/Provider';
import App from './App';
import * as serviceWorker from './serviceWorker';

import {icons} from './assets/icons';

React.icons = icons;

ReactDOM.render(
    <ApolloProvider>
        <IntlProvider>
            <App/>
        </IntlProvider>
    </ApolloProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
